export default function extraValidityDirective() {
  'ngInject';

  const errorsObjAttrName = 'validationObject';
  let scope = {};

  scope[`${errorsObjAttrName}`] = '=';

  function normalizeFormName(name) {
    //String controllerAs syntax out of form.
    return name.replace(/(.*\.)/, '');
  }

  return {
    restrict: 'A',
    require: 'form',
    scope,
    link: function ($scope, $element, $attrs, formCtrl) {
      let normalizedFormName = normalizeFormName(formCtrl.$name);

      //Iterates over the form to find any controls with keys corresponding to errors.
      function mapValidity(form, errors) {
        Object.keys(errors).map(function (errorKey) {
          if (form.hasOwnProperty(errorKey)) {
            //TODO - possibly pass the message in error.
            form[errorKey].$setTouched();
            form[errorKey].$viewChangeListeners.push(function(){
              form[errorKey].$setValidity('server-response', true);
            });
            form[errorKey].$setValidity('server-response', false);
          }
        });
      }

      if ($attrs.hasOwnProperty(errorsObjAttrName)) {
        $scope.$watch(errorsObjAttrName, function (newErrors) {
          if (newErrors && newErrors.hasOwnProperty(normalizedFormName)) {
            mapValidity(formCtrl, newErrors[normalizedFormName]);
          }
        });
      }
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/extraValidity/extraValidity.directive.js
 **/